import {IonContent, IonPage} from '@ionic/react';
import {AppHeader} from "@/components/layout/AppHeader";
import {BottomNav} from "@/components/layout/BottomNav";
import {PageTitle} from "@/components/layout/PageTitle";
import {useOrganization} from "@/hooks/useOrganization";
import {DashboardGrid} from "@/components/dashboard/DashboardGrid";
import {AtmosphericPressureWidget} from "@/components/dashboard/widgets/AtmosphericPressureWidget";
import {SuggestedTemperatureWidget} from "@/components/dashboard/widgets/SuggestedTemperatureWidget";


const Dashboard: React.FC = () => {
    const {data: organization, isLoading} = useOrganization();

    return (
        <IonPage>
            <AppHeader/>
            <IonContent fullscreen>
                <PageTitle loading={isLoading}>
                    {organization?.name || 'Dashboard'}
                </PageTitle>
                <DashboardGrid>
                    {/* Progression saison - Full width */}
                    {/*<SeasonProgressWidget/>*/}

                    {/* Pression atmosphérique - Half width */}
                    <AtmosphericPressureWidget/>
                    <SuggestedTemperatureWidget/>

                    {/* Placeholder - Half width */}
                    <div
                        className="bg-white dark:bg-gray-800 rounded-lg p-4 min-h-[140px] flex items-center justify-center border border-gray-200 dark:border-gray-700">
                        <span className="text-gray-400 text-sm">Widget à venir</span>
                    </div>
                </DashboardGrid>
            </IonContent>
            <BottomNav/>
        </IonPage>
    );
};

export default Dashboard;